import { render, staticRenderFns } from "./inbox.vue?vue&type=template&id=7a51a62f&scoped=true&"
import script from "./inbox.vue?vue&type=script&lang=ts&"
export * from "./inbox.vue?vue&type=script&lang=ts&"
import style0 from "./inbox.vue?vue&type=style&index=0&id=7a51a62f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51a62f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdminClientSessionBar: require('/home/vsts/work/1/s/frontend/components/admin-client-session-bar.vue').default,AccountStatusBar: require('/home/vsts/work/1/s/frontend/components/account-status-bar.vue').default,Navigation: require('/home/vsts/work/1/s/frontend/components/navigation.vue').default,Toast: require('/home/vsts/work/1/s/frontend/components/notification/toast.vue').default,SystemDialog: require('/home/vsts/work/1/s/frontend/components/system-dialog.vue').default,SessionManagementNotification: require('/home/vsts/work/1/s/frontend/components/session-management-notification.vue').default,PersistentNotification: require('/home/vsts/work/1/s/frontend/components/persistent-notification.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
